module.exports = __webpack_public_path__ + "static/media/payTM.c6c5d5d0.svg";